import Queue from './queue.js';
const pluginName = 'ajaxqueue';

export default {
    init() {
        $.fn[pluginName] = function() {
            let queue = new Queue();
            queue.init();
            queue.run();
        };

        $(document)[pluginName]();
    }
};
